import React from 'react';
import {
  number, func, bool, string,
} from 'prop-types';
import {
  omit, pipe, when, always, min, max,
} from 'ramda';
import RCSlider from 'rc-slider';
import Currency from './Currency';

import './Slider.scss';

const Slider = ({
  minValue,
  maxValue,
  isCurrency,
  currency,
  value: rawValue,
  ...props
}) => {
  const value = pipe(
    parseInt,
    when(Number.isNaN, always(minValue)),
    max(minValue),
    min(maxValue)
  )(rawValue);

  return (
    <span className="slider" data-selector-type="slider">
      <RCSlider {...omit(['onBlur'], props)} value={value} min={minValue} max={maxValue} />
      {isCurrency && (
        <div className="slider-sub-text-wrapper" data-selector-type="slider-currency">
          <Currency currencyText={currency} value={minValue} />
          <Currency currencyText={currency} value={maxValue} />
        </div>
      )}
    </span>
  );
};

Slider.defaultProps = {
  minValue: 0,
  maxValue: 100,
  step: 1,
};

Slider.propTypes = {
  defaultValue: number,
  value: number,
  minValue: number,
  maxValue: number,
  step: number,
  onBeforeChange: func,
  onChange: func,
  onAfterChange: func,
  isCurrency: bool,
  currency: string,
};

export default Slider;
